import React from 'react';
import { Button } from './Button';
import { GiftIcon, SparklesIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://www.lunaycalma.com/cart/46841754419354:1';
export function BundleOffer() {
  return <section className="w-full py-20 bg-gradient-to-br from-emerald-50 via-white to-cyan-50" data-id="element-20">
      <div className="max-w-6xl mx-auto px-6" data-id="element-21">
        <div className="text-center mb-12" data-id="element-22">
          <h2 className="font-serif text-4xl lg:text-5xl text-navy-900 mb-4" data-id="element-23">
            💰 Oferta Completa
          </h2>
          <p className="text-xl text-gray-600" data-id="element-24">
            El método completo + 2 bonos digitales GRATIS
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden" data-id="element-25">
          <div className="grid lg:grid-cols-2 gap-8" data-id="element-26">
            {/* Left: Product Image */}
            <div className="relative bg-gradient-to-br from-emerald-100 to-cyan-100 p-12 flex items-center justify-center" data-id="element-27">
              <div className="relative" data-id="element-28">
                <img src="https://cdn.magicpatterns.com/uploads/q3FcGqGMwQVZL9GK8NVq6q/ChatGPT_Image_19_dic_2025,_12_22_05.png" alt="Sobrevive a la Quincena - Producto Principal" className="w-full rounded-2xl shadow-2xl" data-id="element-29" />
                <div className="absolute -top-4 -right-4 bg-gradient-to-r from-emerald-400 to-cyan-500 text-white px-6 py-3 rounded-full font-bold text-lg shadow-xl flex items-center gap-2" data-id="element-30">
                  <SparklesIcon className="w-5 h-5" data-id="element-31" />
                  PRINCIPAL
                </div>
              </div>
            </div>

            {/* Right: Offer Details */}
            <div className="p-8 lg:p-12 flex flex-col justify-center space-y-6" data-id="element-32">
              <div data-id="element-33">
                <h3 className="font-serif text-3xl text-navy-900 mb-6" data-id="element-34">
                  Lo que recibes hoy:
                </h3>

                <div className="space-y-6" data-id="element-35">
                  {/* Main Product - EMPHASIZED */}
                  <div className="relative bg-gradient-to-br from-emerald-900 via-teal-800 to-cyan-900 text-white rounded-2xl p-8 shadow-xl border-4 border-emerald-400" data-id="element-36">
                    <div className="absolute -top-3 -left-3 bg-emerald-400 text-navy-900 px-4 py-1 rounded-full text-xs font-bold uppercase tracking-wide" data-id="element-37">
                      Producto Principal
                    </div>
                    <div className="flex items-start gap-4 mb-4" data-id="element-38">
                      <span className="text-4xl" data-id="element-39">💰</span>
                      <div className="flex-1" data-id="element-40">
                        <p className="font-bold text-2xl mb-2" data-id="element-41">
                          Sobrevive a la Quincena
                        </p>
                        <p className="text-sm text-gray-300 mb-3" data-id="element-42">
                          eBook Digital en PDF — Acceso Inmediato
                        </p>
                        <p className="text-sm text-gray-200 leading-relaxed" data-id="element-43">
                          50 hacks reales y probados para manejar tu dinero sin
                          sacrificios extremos. El primer paso hacia tu libertad
                          financiera.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center justify-between pt-4 border-t border-white/20" data-id="element-44">
                      <span className="text-gray-300 text-sm" data-id="element-45">
                        Valor individual:
                      </span>
                      <span className="text-emerald-400 font-bold text-2xl" data-id="element-46">
                        $9.97
                      </span>
                    </div>
                  </div>

                  {/* Bonus 1 - SMALLER */}
                  <div className="border-2 border-emerald-200 rounded-xl p-5 bg-emerald-50/50" data-id="element-47">
                    <div className="flex items-center gap-2 mb-3" data-id="element-48">
                      <GiftIcon className="w-4 h-4 text-emerald-600" data-id="element-49" />
                      <span className="text-emerald-600 font-bold text-xs uppercase tracking-wide" data-id="element-50">
                        Bono Gratis #1
                      </span>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-51">
                      <span className="text-xl" data-id="element-52">📱</span>
                      <div className="flex-1" data-id="element-53">
                        <p className="font-bold text-navy-900 text-sm mb-1" data-id="element-54">
                          30 Noches para Dormir en Paz
                        </p>
                        <p className="text-xs text-gray-600" data-id="element-55">
                          Método para calmar la ansiedad nocturna
                        </p>
                      </div>
                      <span className="text-gray-400 line-through text-xs" data-id="element-56">
                        $15
                      </span>
                    </div>
                  </div>

                  {/* Bonus 2 - SMALLER */}
                  <div className="border-2 border-emerald-200 rounded-xl p-5 bg-emerald-50/50" data-id="element-57">
                    <div className="flex items-center gap-2 mb-3" data-id="element-58">
                      <GiftIcon className="w-4 h-4 text-emerald-600" data-id="element-59" />
                      <span className="text-emerald-600 font-bold text-xs uppercase tracking-wide" data-id="element-60">
                        Bono Gratis #2
                      </span>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-61">
                      <span className="text-xl" data-id="element-62">📱</span>
                      <div className="flex-1" data-id="element-63">
                        <p className="font-bold text-navy-900 text-sm mb-1" data-id="element-64">
                          Glow Up Bichota
                        </p>
                        <p className="text-xs text-gray-600" data-id="element-65">
                          Guía para descubrir tu poder femenino
                        </p>
                      </div>
                      <span className="text-gray-400 line-through text-xs" data-id="element-66">
                        $15
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="border-t border-gray-200 pt-6" data-id="element-67">
                <div className="flex items-center justify-between mb-4" data-id="element-68">
                  <span className="text-gray-500 line-through text-xl" data-id="element-69">
                    Valor total: $40
                  </span>
                  <span className="text-red-500 font-bold text-lg" data-id="element-70">
                    -75% OFF
                  </span>
                </div>

                <div className="bg-gradient-to-r from-emerald-50 to-cyan-50 rounded-xl p-4 mb-6 border-2 border-emerald-300" data-id="element-71">
                  <div className="flex items-baseline justify-center gap-2" data-id="element-72">
                    <span className="text-sm text-gray-600" data-id="element-73">
                      Precio de hoy:
                    </span>
                    <span className="text-5xl font-bold text-navy-900" data-id="element-74">
                      $9.97
                    </span>
                    <span className="text-xl text-gray-600" data-id="element-75">USD</span>
                  </div>
                </div>

                <Button size="lg" className="w-full bg-gradient-to-r from-emerald-500 to-cyan-500 hover:from-emerald-600 hover:to-cyan-600" href={CHECKOUT_URL} data-id="element-76">
                  Sí, quiero empezar mi camino hacia la libertad financiera
                </Button>

                <p className="text-center text-sm text-gray-500 mt-4" data-id="element-77">
                  ✓ Descarga instantánea • ✓ Garantía de 7 días • ✓ Formato PDF
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}